import { requestWithToken } from '../utilities/request';
const path = '/api/private/user_mail_settings';

const list = () => {
  return requestWithToken({
    method: 'GET',
    url: path,
  });
};

/**
 *
 * @param data {object}
 */
const updateUserMailSettings = data => {
  return requestWithToken({
    method: 'PATCH',
    url: path,
    data,
  });
};

export const UserMailSettingsService = {
  list,
  updateUserMailSettings,
};



// WEBPACK FOOTER //
// ./src/services/UserMailSettings.js